export type UserDisplayNameStringType = {
	country_code: string;
	phone: string;
	first_name: string;
	last_name: string;
};

const constructUserDisplayNameString: ({
	country_code,
	phone,
	first_name,
	last_name,
}: UserDisplayNameStringType) => string = ({
	country_code = "+91",
	phone = "",
	first_name = "",
	last_name = "",
}: UserDisplayNameStringType) => {
	let user_display_name_string: string = "";
	if (first_name.trim().length > 0) {
		user_display_name_string += first_name.trim();
	}
	if (last_name.trim().length > 0) {
		user_display_name_string += ` ${last_name.trim()}`;
	}
	if (
		user_display_name_string.trim().length === 0 &&
		((phone.length >= 7 && phone.length <= 15 && country_code !== "+91") ||
			(phone.length === 10 && country_code === "+91")) &&
		country_code.length >= 2 &&
		country_code.length <= 4
	) {
		user_display_name_string += ` ${country_code.trim()} ${phone.trim()}`;
	}
	return user_display_name_string;
};

export default constructUserDisplayNameString;
